import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DLPRestUtilityService } from '../rest/dlprest-utility.service';
import { LoginRenderingService } from '../login/login-rendering.service';
import { LoginDTO } from 'src/app/models/login/loginDetails';
import { Login } from 'src/app/models/login/sendLoginDetails';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { DlpUtilityService } from '../utility/dlp-utility.service';
import { LocalService } from '../utility/local.service';
const CACHABLE_URL = ["/autofill", "/asset/details/"];

@Injectable({
  providedIn: 'root'
})
export class AuthorisationService {

  constructor(
    private dlpRestService: DLPRestUtilityService,
    private loginService: LoginRenderingService,
    private router: Router,
    private data: ApiService,
    private dlpUtilityService: DlpUtilityService,
    private localService: LocalService
  ) {
  }



  login(login: Login): Promise<number> {
    // console.log(login);
    return new Promise((resolve, reject) => {
      this.dlpRestService.onLogin(login).subscribe(res => {
        let data = res.body;
        // console.log(res);
        if (res.status === 200) {
          // login successful if there's a jwt token in the response
          if (data || data.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem('currentUser', JSON.stringify(data));
            //start Added by Birender for testing of encripted local storage currently no use
            // this.localService.setSecureValue('currentUser1', JSON.stringify(data));
           // end 

            localStorage.setItem('SSOLOGIN', data.userId);
            this.localService.setSecureValue('SSOLOGIN', data.userId);


            this.loginService.login = data;
            this.loginService.currentUser= data
            window.localStorage.setItem('theme-name', data.brands);
            window.localStorage.setItem('logoImage', data.brands);
            this.data.setLocalStorage(data.brands);
            localStorage.removeItem('logoImage');
            // const brand = res.body.brands;
          }
          resolve(200);
        }
      },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            //A client-side or network error occurred.				 
            console.log('An error occurred:', err.error.message);
          } else {
            //Backend returns unsuccessful response codes such as 404, 500 etc.				 
            console.log('Backend returned status code: ', err.status);
            console.log('Response body:', err.error);
            reject(err)
          }
        }
      )
    })
  }

  isAuthenticated(): boolean {
    // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    let currentUser = this.loginService.currentUser;

    if (currentUser && currentUser.token) {
      return true;
    }
    else {
      return false;//rechange it
    }
  }
  

  logout(): void {
    localStorage.removeItem('currentUser');
    this.localService.removeSecureValue("SSOLOGIN");
    this.loginService.currentUser= '';
    this.localService.clearToken();
    this.data.setLocalStorage('nissan');
    let keys = Object.keys(localStorage);
    CACHABLE_URL.forEach((url) => {
      keys.forEach((key) => {
        if (key.indexOf(url) > -1) {
          localStorage.removeItem(key);
        }
      })
    })
    localStorage.removeItem('SSOLOGIN');
    this.router.navigate(['/login']);
  }

  logoutExpireToken(): void{
    this.dlpRestService.logoutToken().subscribe(res => {
      console.log("---------logout expired");
    })

  }

}
